import axios from "axios";
import { addAuthToken } from "./axios";

const hotelApi = axios.create({
  baseURL : `https://menastockinstore.com/hotelsapi/`,
});

hotelApi.interceptors.request.use(
  addAuthToken,
  (error) => Promise.reject(error)
);

export default hotelApi;